import { render, staticRenderFns } from "./PValid.vue?vue&type=template&id=c82fecb4"
import script from "./PValid.vue?vue&type=script&lang=js"
export * from "./PValid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports